export const cueSheetTypes = {
    music: 'MUSIC',
    sfx: 'SFX',
    mix: 'MIX'
}